// * GET =====================================
export const UTILS_GET_ALGORITHM_PARAMETERS = `/utils/algorithm_parameters`;

export const UTILS_GET_GET_IMAGE_FACES = `/utils/get_image_faces`;

export const UTILS_GET_GET_IMAGE_FACES_SUGGEST = `/utils/get_image_faces_suggest`;

export const UTILS_GET_I18N_TABLE = `/utils/i18n_table`;

export const UTILS_GET_I18N = (lang: string) => `/utils/i18n?lang=${lang}`;

export const UTILS_GET_SCHEMA = `/utils/schema`;

export const UTILS_GET_TIMEZONES = `/utils/timezones`;

export const UTILS_GET_LANGUAGES = `/utils/languages`;

export const UTILS_GET_COVER_PERIODS = `/utils/cover_periods`;

export const UTILS_GET_PROFIT_CENTERS = `/utils/profit_centers`;

export const UTILS_GET_PARTNER_AGENCIES = `/utils/partner_agencies`;

export const UTILS_GET_COUNTRIES = `/utils/countries`;

export const UTILS_GET_CITIES = `/utils/cities`;

// * PATCH ===================================

// * POST ====================================
export const UTILS_POST_I18N = `/utils/i18n`;

export const UTILS_POST_ASSIGN_FACE = `/utils/assign_face`;

export const UTILS_POST_ASSIGN_LOGO = `/utils/assign_logo`;

export const UTILS_POST_TRANSLATE = `/utils/translate`;

// * DELETE ==================================

// * PUT =====================================
